import { useParams, useNavigate } from 'react-router-dom';
import GamePlayOverlay from '../components/GamePlayOverlay/GamePlayOverlay';
import { useEffect, useState } from 'react';
import pb from '../pocketbase';

export default function GamePlayPage({ game, onClose = () => { } }) {
  const { gameId } = useParams();
  const navigate = useNavigate();
  const [resolvedGame, setResolvedGame] = useState(game || null);

  useEffect(() => {
    let isMounted = true;
    (async () => {
      if (game) return; // пришло сверху
      if (!gameId) return;
      try {
        const data = await pb.collection('games').getOne(gameId);
        if (isMounted) setResolvedGame({
          id: data.id,
          title: data.title,
          subtitle: data.subtitle,
          description: data.description,
          coverUrl: data.cover ? `${pb.baseURL}/api/files/games/${data.id}/${data.cover}` : null,
          slug: data.slug,
          priceCents: data.price || 0,
          currency: 'RUB',
          subscriptionIncluded: false,
          isFree: data.price === 0
        });
      } catch (e) {
        navigate('/my-games');
      }
    })();
    return () => { isMounted = false; };
  }, [gameId, game, navigate]);

  if (!resolvedGame) return null;
  return <GamePlayOverlay game={resolvedGame} onClose={() => navigate('/my-games')} />;
}
